import { render, staticRenderFns } from "./competency_main.vue?vue&type=template&id=2f4a8d60&scoped=true&"
import script from "./competency_main.vue?vue&type=script&lang=js&"
export * from "./competency_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a8d60",
  null
  
)

export default component.exports